/* tslint:disable */
/* eslint-disable */
/**
 * dynamic-pricing-api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { Strategy } from '../models';
// @ts-ignore
import type { StrategyCopyResult } from '../models';
/**
 * StrategyApi - axios parameter creator
 * @export
 */
export const StrategyApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} [sourceFacilityId] 
         * @param {number} [strategyId] 
         * @param {string} [destFacilityIdList] 
         * @param {string} [overrideDynPricingStrategyName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStrategyCopyGet: async (sourceFacilityId?: number, strategyId?: number, destFacilityIdList?: string, overrideDynPricingStrategyName?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Strategy/Copy`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (sourceFacilityId !== undefined) {
                localVarQueryParameter['sourceFacilityId'] = sourceFacilityId;
            }

            if (strategyId !== undefined) {
                localVarQueryParameter['strategyId'] = strategyId;
            }

            if (destFacilityIdList !== undefined) {
                localVarQueryParameter['destFacilityIdList'] = destFacilityIdList;
            }

            if (overrideDynPricingStrategyName !== undefined) {
                localVarQueryParameter['overrideDynPricingStrategyName'] = overrideDynPricingStrategyName;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [strategyId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStrategyDelete: async (strategyId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Strategy`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (strategyId !== undefined) {
                localVarQueryParameter['strategyId'] = strategyId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [facilityId] 
         * @param {string} [strategyName] 
         * @param {number} [strategyId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStrategyExistsGet: async (facilityId?: number, strategyName?: string, strategyId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Strategy/Exists`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (facilityId !== undefined) {
                localVarQueryParameter['facilityId'] = facilityId;
            }

            if (strategyName !== undefined) {
                localVarQueryParameter['strategyName'] = strategyName;
            }

            if (strategyId !== undefined) {
                localVarQueryParameter['strategyId'] = strategyId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [facilityId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStrategyGet: async (facilityId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Strategy`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (facilityId !== undefined) {
                localVarQueryParameter['facilityId'] = facilityId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Strategy} [strategy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStrategyPost: async (strategy?: Strategy, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Strategy`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(strategy, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Strategy} [strategy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStrategyPut: async (strategy?: Strategy, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Strategy`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(strategy, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * StrategyApi - functional programming interface
 * @export
 */
export const StrategyApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = StrategyApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} [sourceFacilityId] 
         * @param {number} [strategyId] 
         * @param {string} [destFacilityIdList] 
         * @param {string} [overrideDynPricingStrategyName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiStrategyCopyGet(sourceFacilityId?: number, strategyId?: number, destFacilityIdList?: string, overrideDynPricingStrategyName?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<StrategyCopyResult>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiStrategyCopyGet(sourceFacilityId, strategyId, destFacilityIdList, overrideDynPricingStrategyName, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StrategyApi.apiStrategyCopyGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [strategyId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiStrategyDelete(strategyId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Strategy>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiStrategyDelete(strategyId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StrategyApi.apiStrategyDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [facilityId] 
         * @param {string} [strategyName] 
         * @param {number} [strategyId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiStrategyExistsGet(facilityId?: number, strategyName?: string, strategyId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<StrategyCopyResult>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiStrategyExistsGet(facilityId, strategyName, strategyId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StrategyApi.apiStrategyExistsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [facilityId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiStrategyGet(facilityId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Strategy>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiStrategyGet(facilityId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StrategyApi.apiStrategyGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {Strategy} [strategy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiStrategyPost(strategy?: Strategy, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Strategy>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiStrategyPost(strategy, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StrategyApi.apiStrategyPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {Strategy} [strategy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiStrategyPut(strategy?: Strategy, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Strategy>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiStrategyPut(strategy, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StrategyApi.apiStrategyPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * StrategyApi - factory interface
 * @export
 */
export const StrategyApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = StrategyApiFp(configuration)
    return {
        /**
         * 
         * @param {number} [sourceFacilityId] 
         * @param {number} [strategyId] 
         * @param {string} [destFacilityIdList] 
         * @param {string} [overrideDynPricingStrategyName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStrategyCopyGet(sourceFacilityId?: number, strategyId?: number, destFacilityIdList?: string, overrideDynPricingStrategyName?: string, options?: any): AxiosPromise<Array<StrategyCopyResult>> {
            return localVarFp.apiStrategyCopyGet(sourceFacilityId, strategyId, destFacilityIdList, overrideDynPricingStrategyName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [strategyId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStrategyDelete(strategyId?: number, options?: any): AxiosPromise<Strategy> {
            return localVarFp.apiStrategyDelete(strategyId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [facilityId] 
         * @param {string} [strategyName] 
         * @param {number} [strategyId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStrategyExistsGet(facilityId?: number, strategyName?: string, strategyId?: number, options?: any): AxiosPromise<Array<StrategyCopyResult>> {
            return localVarFp.apiStrategyExistsGet(facilityId, strategyName, strategyId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [facilityId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStrategyGet(facilityId?: number, options?: any): AxiosPromise<Array<Strategy>> {
            return localVarFp.apiStrategyGet(facilityId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Strategy} [strategy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStrategyPost(strategy?: Strategy, options?: any): AxiosPromise<Strategy> {
            return localVarFp.apiStrategyPost(strategy, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Strategy} [strategy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStrategyPut(strategy?: Strategy, options?: any): AxiosPromise<Strategy> {
            return localVarFp.apiStrategyPut(strategy, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * StrategyApi - object-oriented interface
 * @export
 * @class StrategyApi
 * @extends {BaseAPI}
 */
export class StrategyApi extends BaseAPI {
    /**
     * 
     * @param {number} [sourceFacilityId] 
     * @param {number} [strategyId] 
     * @param {string} [destFacilityIdList] 
     * @param {string} [overrideDynPricingStrategyName] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StrategyApi
     */
    public apiStrategyCopyGet(sourceFacilityId?: number, strategyId?: number, destFacilityIdList?: string, overrideDynPricingStrategyName?: string, options?: RawAxiosRequestConfig) {
        return StrategyApiFp(this.configuration).apiStrategyCopyGet(sourceFacilityId, strategyId, destFacilityIdList, overrideDynPricingStrategyName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [strategyId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StrategyApi
     */
    public apiStrategyDelete(strategyId?: number, options?: RawAxiosRequestConfig) {
        return StrategyApiFp(this.configuration).apiStrategyDelete(strategyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [facilityId] 
     * @param {string} [strategyName] 
     * @param {number} [strategyId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StrategyApi
     */
    public apiStrategyExistsGet(facilityId?: number, strategyName?: string, strategyId?: number, options?: RawAxiosRequestConfig) {
        return StrategyApiFp(this.configuration).apiStrategyExistsGet(facilityId, strategyName, strategyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [facilityId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StrategyApi
     */
    public apiStrategyGet(facilityId?: number, options?: RawAxiosRequestConfig) {
        return StrategyApiFp(this.configuration).apiStrategyGet(facilityId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Strategy} [strategy] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StrategyApi
     */
    public apiStrategyPost(strategy?: Strategy, options?: RawAxiosRequestConfig) {
        return StrategyApiFp(this.configuration).apiStrategyPost(strategy, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Strategy} [strategy] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StrategyApi
     */
    public apiStrategyPut(strategy?: Strategy, options?: RawAxiosRequestConfig) {
        return StrategyApiFp(this.configuration).apiStrategyPut(strategy, options).then((request) => request(this.axios, this.basePath));
    }
}

